module.exports = __webpack_public_path__ + "static/media/sidenav-icon-exit.ee4da482.svg";